
import React from 'react';
import PropTypes from 'prop-types';

import SeedProductResultsListContainer from 'edit/seed-product-selector/SeedProductResultsListContainer';
import SeedProductSearchStatus from 'edit/seed-product-selector/SeedProductSearchStatus';

const SeedProductSearchDisplay = ({
  searchResults,
  searchStatus
}) => searchResults.length ? (
  <SeedProductResultsListContainer />
) : (
  <SeedProductSearchStatus searchStatus={searchStatus} />
);
SeedProductSearchDisplay.propTypes = {
  searchResults: PropTypes.array.isRequired,
  searchStatus: PropTypes.string.isRequired
};
export default SeedProductSearchDisplay;
